import * as types from './mutations-types'
import memberConsumingRecordsApi from '../../../../api/wx-member/member-consuming-records/member-consuming-records'
import * as DataTypeConstants from '../../../../constants/DataTypeConstants'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import FormatTableFieldUtils from '../../../../common/utils/format-table-field-util'

export default {
  getConsumedCoupon: ({commit}) => {
    memberConsumingRecordsApi.getConsumedCoupon()
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result, params).then(res => {
          result = res
          commit(types.CONSUMED_COUPON_INFO, result)
        })
      })
  },
  updateCouponRecord: ({commit}, data) => {
    commit(types.UPDATE_COUPON_INFO_RECORD, data)
  },
  updateCouponFalseRecord: ({commit}, data) => {
    commit(types.UPDATE_COUPON_INFO_FALSE_RECORD, data)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/store/actions.js